import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from "@angular/router";
import { ChartsModule } from "ng2-charts";
import { HttpClientModule, HttpClientXsrfModule,  HttpClient, HTTP_INTERCEPTORS  } from "@angular/common/http";
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import {  AmplifyAngularModule, AmplifyService } from 'aws-amplify-angular';
import { OrderModule } from "ngx-order-pipe";
import { FormsModule } from '@angular/forms';
import { JwtInterceptor, ErrorInterceptor} from './common/interceptors/index';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ResponsiveModule } from "ngx-responsive";


// general Views components
import { AppComponent } from './app.component';
import { HeaderComponent } from './header/header.component';
import { HeaderMyAccountComponent } from './header/header-my-account/header-my-account.component';
import { FooterComponent } from './footer/footer.component';
import { FooterMyAccountComponent } from './footer/footer-my-account/footer-my-account.component';
import { HomeComponent } from './page/home/home.component';
import { CmsComponent } from './page/cms/cms.component';
import { NotFoundComponent } from './page/not-found/not-found.component';


// My account
import { MyaccountComponent } from './myaccount/myaccount.component';
import { DashboardComponent } from './myaccount/dashboard/dashboard.component';
import { CoverageDetailsComponent } from './myaccount/coverage-details/coverage-details.component';
import { PaymentsComponent } from './myaccount/payments/payments.component';
import { ProfileComponent } from './myaccount/profile/profile.component';
import { ServiceRequestsComponent } from './myaccount/service-requests/service-requests.component';
import { NewRequestComponent } from './myaccount/service-requests/new-request/new-request.component';
import { DetailRequestComponent } from './myaccount/service-requests/detail-request/detail-request.component';


// Pipes
import {SafePipe} from "./common/pipes/safe.pipe";

// Services
import { CinchDataService } from "./common/service/cinch-data.service";
import { AuthGuardService } from './common/service/auth-guard.service';
import { AuthService } from "./common/service/auth.service";


// UI
import { NotificationsComponent } from './ui/notifications/notifications.component';
import { AlertsComponent } from './ui/notifications/alerts/alerts.component';
import { NavComponent } from './ui/nav/nav.component';
import { NavItemComponent } from './ui/nav/nav-item/nav-item.component';
import { ModalsComponent } from './ui/modals/modals.component';
import { AddressComponent } from './ui/types/address/address.component';
import { InfoBlockComponent } from './ui/info-block/info-block.component';

// Test Component
// TODO: comment this on production.
import { StyleComponent } from './ui/test/style/style.component';
import { UisComponent } from './ui/test/uis/uis.component';
import { CinchDataTestComponent } from './ui/test/cinch-data-test/cinch-data-test.component';
import { NotificationsTestComponent } from './ui/test/notifications-test/notifications-test.component';
import { NavTestComponent } from './ui/test/nav-test/nav-test.component';
import { AnimationsTestComponent } from './ui/test/animations-test/animations-test.component';





// rounding
const appRoutes: Routes = [
    { path: '', redirectTo: 'auth/login', 'pathMatch': 'full' },
    { path: 'home.html', component: HomeComponent },

    // Auth Module
    { path: 'auth', loadChildren: './auth/auth.module#AuthModule' },

    // My account
    { path: 'myaccount', canActivate: [AuthGuardService], component: MyaccountComponent, children: [
            { path: '', redirectTo: 'dashboard', 'pathMatch': 'full' },
            { path: 'dashboard', component: DashboardComponent },
            { path: 'coverage-details', component: CoverageDetailsComponent },
            { path: 'service-requests', component: ServiceRequestsComponent},
            { path: 'payments', component: PaymentsComponent },
            { path: 'profile', component: ProfileComponent },
            { path: 'detail-requests', component: DetailRequestComponent },
            { path: 'new-requests', component: NewRequestComponent }
      ]},

    // CMS
    { path: 'page/404', component: NotFoundComponent },
    { path: 'page/home', component: HomeComponent },
    { path: 'page/:slug', component: CmsComponent },

    // UI and visual Test
    // TODO: comment this routes before send it to production.
    { path: 'test', component: UisComponent, children: [
            { path: '', redirectTo: 'style', 'pathMatch': 'full' },
            { path: 'style', component: StyleComponent },
            { path: 'notifications', component: NotificationsTestComponent },
            { path: 'cinch-data', component: CinchDataTestComponent },
            { path: 'nav', component: NavTestComponent },
            { path: 'animations', component: AnimationsTestComponent }
        ]},

    // Anything else 404
    { path: '**', redirectTo: 'page/404' }
];

const _jwtInterceptor ={
    provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true
};
const _errorInterceptor = {
    provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true
};

@NgModule({
  declarations: [
      // Test
      // TODO: comment this section for production.
      StyleComponent,
      UisComponent,
      CinchDataTestComponent,
      NotificationsTestComponent,
      NavTestComponent,
      AnimationsTestComponent,

      // App Components
      AppComponent,
      HeaderComponent,
      FooterComponent,
      HomeComponent,
      CmsComponent,
      NotFoundComponent,

      // App Dashboard
      DashboardComponent,
      HeaderMyAccountComponent,
      FooterMyAccountComponent,
      MyaccountComponent,
      CoverageDetailsComponent,
      ServiceRequestsComponent,
      PaymentsComponent,
      NewRequestComponent,
      DetailRequestComponent,
      ProfileComponent,

      // UI
      NotificationsComponent,
      AlertsComponent,
      NavComponent,
      NavItemComponent,
      ModalsComponent,
      InfoBlockComponent,
      AddressComponent,




  ],
  imports: [
      BrowserModule,
      ChartsModule,
      OrderModule,
      NgbModule,
      FormsModule,
      RouterModule.forRoot(appRoutes, {useHash: true}),
      HttpClientModule,
      HttpClientXsrfModule.withOptions({
          cookieName: 'tlsc-home-a5-Xsrf-Cookie',
          headerName: 'tlsc-home-a5-Header',
      }),
      AmplifyAngularModule,
      ResponsiveModule.forRoot(),
      BrowserAnimationsModule
  ],
  providers: [
      CinchDataService,
      AmplifyService,
      AuthGuardService,
      AuthService,
      _jwtInterceptor,
      _errorInterceptor
  ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
